export const PROFILE = 'PROFILE';
export const LIGHT_PROFILE = 'LIGHT_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const SUBMIT_PROMOTIONAL_DETAILS = 'SUBMIT_PROMOTIONAL_DETAILS';
export const SUBMIT_PROMOTIONAL_DETAILS_SUCCESS = 'SUBMIT_PROMOTIONAL_DETAILS_SUCCESS';
export const SUBMIT_PROMOTIONAL_DETAILS_FAILED = 'SUBMIT_PROMOTIONAL_DETAILS_FAILED';
export const CLOSE_PROMOTIONAL_DETAILS_MODAL = 'CLOSE_PROMOTIONAL_DETAILS_MODAL';
